<template>
    <div>
        <b-card v-if="!statusEdit">
            <div class="d-flex justify-content-between align-items-center mb-2">
                <h3 class="mb-0">Peer Services Dashboard</h3>
            </div>

            <b-row class="mb-1">
                <b-col md="4">
                    <b-form-group label="Client Name" label-for="client-name">
                        <v-select
                            id="client-name"
                            v-model="clientName"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            placeholder="Client Name"
                            label="value"
                            :dense="true"
                            :options="optionsClientName"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Peer Service Status" label-for="filter-main">
                        <v-select
                            id="filter-main"
                            v-model="filterMain"
                            :options="['All', 'Open', 'Closed']"
                            :clearable="false"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Referral Type" label-for="filter-type">
                        <v-select
                            id="filter-type"
                            v-model="filterType"
                            :options="['All', 'Referred to Clinician and Peer Advocate', 'Referred to Peer Advocate']"
                            :clearable="false"
                        />
                    </b-form-group>
                </b-col>
            </b-row>

            <div class="text-center my-3" v-if="!loadDataPage">
                <b-spinner variant="primary" />
                <h5 class="mt-1">LOADING...</h5>
            </div>

            <b-table
                v-else
                :items="filteredItems"
                :fields="fields"
                responsive
                striped
                hover
                show-empty
                class="cursor-pointer"
                @row-clicked="onRowSelected"
            >
                <template #cell(clientId)="data">
                    <!-- <router-link :to="{ name: 'edit-client', params: { id: data.item.rawClientId } }"> -->
                        {{ data.item.clientName || data.item.rawClientId }}
                    <!-- </router-link> -->
                </template>

                <template #cell(peerAssigned)="data">
                    {{ data.item.peerAssignedName || '-' }}
                </template>

                <template #cell(activityStatus)="data">
                    <!-- <b-badge :variant="data.item.mainStatus === 'Open' ? 'success' : 'secondary'"> -->
                    <span class="ps-break-line">{{ formatActivityStatusDisplay(data.item.activityStatus) || '-' }}</span>
                    <!-- </b-badge> -->
                </template>

                <template #cell(engagedStatus)="data">
                    {{ data.item.engagedStatus || '-' }}
                </template>

                <template #cell(actions)="data">
                    <b-button
                        size="sm"
                        variant="outline-primary"
                        @click="goToClientActivity(data.item.rawClientId, data.item.id)"
                    >
                        View
                    </b-button>
                </template>
            </b-table>
        </b-card>

        <b-card v-else>
            <div>
                <edit-client-activity :idClientActivity="idClientActivity" :isVSEForm="isVSEForm" @statusEditClientActivity="statusEdit = $event" @pushEditButton="pushEditButton = $event" />
            </div>
        </b-card>
    </div>
</template>

<script>
import { BCard, BRow, BCol, BFormGroup, BFormInput, BTable, BSpinner, BBadge, BButton } from 'bootstrap-vue'
import EditClientActivity from './components/EditClientActivity.vue'
import vSelect from 'vue-select'
import { db, auth } from '@/firebase'
import { watch } from 'vue';

export default {
    components: {
        BCard, BRow, BCol, BFormGroup, BFormInput, BTable, BSpinner, BBadge, BButton,
        vSelect,
        EditClientActivity,
    },
    data() {
        return {
            loadDataPage: false,
            isAdmin: false,
            managerPA: false,
            managerPeerSupervisor: false,
            hasAccess: false,
            clientName: { id: 0, uid: 0, value: 'All Clients' },
            optionsClientName: [],
            filterMain: 'All',
            filterType: 'All',
            items: [],
            fields: [
                { key: 'clientId', label: 'Client Name', sortable: true },
                { key: 'activityStatus', label: 'Activity Status', sortable: true },
                { key: 'engagedStatus', label: 'Engaged Status', sortable: true },
                { key: 'peerAssigned', label: 'Peer', sortable: true },
                { key: 'contactDate', label: 'Contact Date', sortable: true },
                { key: 'admissionDate', label: 'Admission Date', sortable: true },
                { key: 'dischargeDate', label: 'Discharge Date', sortable: true },
                { key: 'peerServicesIntake', label: 'Peer Services Intake', sortable: true },
                { key: 'peerServicesDischarge', label: 'Peer Services Discharge', sortable: true },
                // { key: 'actions', label: '', sortable: false },
            ],

            statusEdit: false,
            statusEditClient: false,
            idClientActivity: '',
        }
    },
    computed: {
        filteredItems() {
            var list = this.items

            if(this.filterMain && this.filterMain !== 'All') {
                list = list.filter(i => i.mainStatus === this.filterMain)
            }

            if(this.filterType && this.filterType !== 'All') {
                list = list.filter(i => i.engagedStatusRaw === this.filterType)
            }

            if(this.clientName && this.clientName.uid !== 0) {
                list = list.filter(i => i.rawClientId === this.clientName.uid)
            }

            return list
        },
    },
    watch: {
        statusEdit(val) {
            if(val) {
                this.statusEditClient = true
                this.$emit('statusEditClient',true)
            } else {
                this.loadDashboardData()
                this.statusEditClient = false
                this.$emit('statusEditClient',false)
            }
        },
    },
    methods: {
        formatActivityStatusDisplay(text) {
            if (!text) return text
            if (text.includes('\n')) return text
            
            var peerParts = [
                'Open for Peer Services',
                'Closed for Peer Services',
                'Discharged from Peer Services'
            ]

            for (var i = 0; i < peerParts.length; i++) {
                var idx = text.indexOf(peerParts[i])
                if (idx > 0) {
                    return text.slice(0, idx).trim() + '\n' + text.slice(idx)
                }
            }
            return text
        },
        buildPeerActivityStatusText(data) {
            var pss = data.peerServiceStatus
            var isEngagedRCPA = data.activityStatus === 'Engaged' && data.engagedStatus === 'Referred to Clinician and Peer Advocate'
            var isEngagedRPA = data.activityStatus === 'Engaged' && data.engagedStatus === 'Referred to Peer Advocate'
            var closedStatuses = ['Closed - Attended First Session', 'Closed - Did not attend first session', 'Closed - Referred to OASAS Program']
            var isClosedPeerActive = closedStatuses.includes(data.activityStatus) && data.referredToPeerAdvocate === 'Yes'

            if(!isEngagedRCPA && !isEngagedRPA && !isClosedPeerActive) return ''
            if(!pss || !pss.main) return ''

            var peerPart = ''
            if(data.psdfDate) {
                peerPart = 'Discharged from Peer Services'
            } else if(pss.main === 'Open') {
                peerPart = 'Open for Peer Services'
            } else if(pss.main === 'Closed') {
                peerPart = 'Closed for Peer Services'
            }
            if(!peerPart) return ''

            if(isEngagedRPA) {
                return peerPart
            }

            if(isClosedPeerActive) {
                return data.activityStatus + '\n' + peerPart
            }

            // isEngagedRCPA
            var clinicalPrefix = 'Engaged'
            if(data.dateOfAdmission && data.removeRecordDischargeData) {
                clinicalPrefix = 'Admitted'
            } else if(data.dateOfAdmission && (!data.dateOfDischarge || data.dateOfDischarge === 'N/A')) {
                clinicalPrefix = 'Admitted'
            } else if(data.dateOfDischarge && data.dateOfDischarge !== 'N/A') {
                clinicalPrefix = 'Discharged'
            }

            return clinicalPrefix + '\n' + peerPart
        },
        buildPeerEngagedStatusText(data) {
            var pss = data.peerServiceStatus
            var isEngagedRCPA = data.activityStatus === 'Engaged' && data.engagedStatus === 'Referred to Clinician and Peer Advocate'
            var isEngagedRPA = data.activityStatus === 'Engaged' && data.engagedStatus === 'Referred to Peer Advocate'
            var closedStatuses = ['Closed - Attended First Session', 'Closed - Did not attend first session', 'Closed - Referred to OASAS Program']
            var isClosedPeerActive = closedStatuses.includes(data.activityStatus) && data.referredToPeerAdvocate === 'Yes'

            if((!isEngagedRCPA && !isEngagedRPA && !isClosedPeerActive) || (data.activityStatus === 'Engaged' && !data.engagedStatus)) return ''
            if(!pss || !pss.main) return ''

            if(data.psdfDate) {
                return data.engagedStatus
            }

            var deepest = ''
            if(pss.main === 'Open' && pss.openStage) {
                deepest = pss.openStage
            } else if(pss.main === 'Closed') {
                if(pss.closedReason === 'Scheduled First Appt' && pss.apptOutcome) {
                    deepest = pss.apptOutcome
                } else if(pss.closedReason) {
                    deepest = pss.closedReason
                }
            }

            return deepest ? data.engagedStatus + ' ' + deepest : data.engagedStatus
        },

        onRowSelected(items) {
            // if(items.contactDateVSE) {
            //     if(this.isPMVSE || this.isSuperAdmin) {
            //         this.idClientActivity = items.id
            //         this.isVSEForm = true
            //         this.statusEdit = true
            //     }
            // } else {
                this.idClientActivity = items.id
                this.isVSEForm = false
                this.statusEdit = true
            // }
        },

        goToClientActivity(clientId, activityId) {
            // this.$router.push({ name: 'edit-client', params: { id: clientId }, query: { activity: activityId } })
        },

        async loadDashboardData() {
            this.loadDataPage = false

            var snap = await db.collection('clientsActivity')
                .where('peerServiceStatus.main', 'in', ['Open', 'Closed'])
                .get()

            var rawItems = []
            var clientIdsToFetch = new Set()

            snap.forEach(doc => {
                var d = doc.data()
                if(!d.peerServiceStatus || !d.peerServiceStatus.main) return

                var activityStatusText = this.buildPeerActivityStatusText(d)
                var engagedStatusText = this.buildPeerEngagedStatusText(d)

                // si no aplica la condición RCPA/RPA, se omite del dashboard
                if(!activityStatusText && !engagedStatusText) return

                if(d.client) clientIdsToFetch.add(d.client)

                rawItems.push({
                    id: doc.id,
                    rawClientId: d.client || '',
                    clientName: '',
                    peerAssignedName: d.peerAssigned && d.peerAssigned.name ? d.peerAssigned.name : '',
                    activityStatus: activityStatusText,
                    engagedStatus: engagedStatusText,
                    engagedStatusRaw: d.engagedStatus || '',
                    mainStatus: d.peerServiceStatus.main,
                    contactDate: d.dateOfContact || '',
                    admissionDate: d.dateOfAdmission || '',
                    dischargeDate: d.dateOfDischarge || '',
                    peerServicesIntake: d.contactDate || '',
                    peerServicesDischarge: d.psdfDate || '',
                })
            })

            // resolver nombres de clientes en batch
            var clientIdsArray = Array.from(clientIdsToFetch)
            var clientNames = {}
            await Promise.all(clientIdsArray.map(async id => {
                var clientDoc = await db.collection('clients').doc(id).get()
                if(clientDoc.exists) {
                    clientNames[id] = (clientDoc.data().firstName || '') + ' ' + (clientDoc.data().lastName || '')
                }
            }))

            rawItems.forEach(item => {
                item.clientName = clientNames[item.rawClientId] || ''
            })

            this.items = rawItems
            this.loadDataPage = true
        },
    },
    created() {
        this.statusEdit = false
        this.statusEditClient = false
        this.idClientActivity = ''

        var user = auth.currentUser
        db.collection('usuarios').doc(user.uid).get()
        .then(userDoc => {
            if(userDoc.data().role === 'admin') {
                this.isAdmin = true
            } else if(userDoc.data().role === 'staff') {
                if(userDoc.data().permissions.includes('program manager - pa')) {
                    this.managerPA = true
                } else if(userDoc.data().permissions.includes('program manager peer supervisor')) {
                    this.managerPeerSupervisor = true
                }
            }

            this.hasAccess = this.isAdmin || this.managerPA || this.managerPeerSupervisor

            if(this.hasAccess) {
                this.loadDashboardData()
            } else {
                this.$router.push({ name: 'not-authorized' })
            }
        })

        this.$http.get('https://us-central1-nycpg-67e48.cloudfunctions.net/app/api/filter/clients')
        .then(res => {
            this.optionsClientName = [{id: 0, uid: 0, value: 'All Clients'}]
            res.data.forEach(ele => {
                this.optionsClientName.push(ele)
            })
        })
    },
}
</script>

<style>
.cancelBtn-modal {
    border-radius: 13px !important;
}
.vs--disabled .vs__selected {
    color: #656b85 !important;
}
/* .btn-primary:hover:focus:active:visited {
    box-shadow: none !important;
}
.btn-primary:hover:focus:active:visited {
    box-shadow: none !important;
} */
.btn-primary:hover {
    box-shadow: none !important;
}
.btn-primary:focus {
    box-shadow: none !important;
}
.btn-primary:active {
    box-shadow: none !important;
}
.btn-primary:visited {
    box-shadow: none !important;
}
.select-utilization-form .vs__dropdown-menu {
    max-height: 185px !important;
    /* position: fixed;
    top: 50px !important;
    left: 50px !important;
    width: 200px !important;
    height: 400px !important;
    background-color: yellow !important;
    z-index: 9999 !important; */
}
.no-permitido {
    cursor: no-drop !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>